import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'users',
    serviceName: 'unitadmin',
    query: gql`
      query users($ids: [String]) {
        users(ids: $ids) {
          data {
            all_roles {
              units {
                id
                title
              }
              shops {
                id
                title
              }
              role {
                id
                title
              }
            }
          }
        }
      }
    `,
  },
  delete: {
    name: 'revokeUserRole',
    serviceName: 'shopadmin',
    query: gql`
      mutation revokeUserRole($user_id: String!, $role_id: String!, $shop_id: String!) {
        revokeUserRole(user_id: $user_id, role_id: $role_id, shop_id: $shop_id) {
          influenced_count
          messages
        }
      }
    `,
  },
};

export default schema;
